// extracted by mini-css-extract-plugin
module.exports = {"headingTitle":"uxcoreId_headingTitle__Or8A0"};